// extracted by mini-css-extract-plugin
module.exports = {"dropzoneStyle":"styles_dropzoneStyle__2b70j","disableDropzoneStyle":"styles_disableDropzoneStyle__xb6Z5","tableOverlayPosition":"styles_tableOverlayPosition__22G9P"};